import { render, staticRenderFns } from "./CarriersModal.vue?vue&type=template&id=d9f22dda&"
import script from "./CarriersModal.vue?vue&type=script&lang=js&"
export * from "./CarriersModal.vue?vue&type=script&lang=js&"
import style0 from "./CarriersModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports